import React from 'react';

const InfoCircleIcon = ({ width = 20, height = 22, color = "#667085", ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M10 9.625C10.3452 9.625 10.625 9.90483 10.625 10.25V14.4167C10.625 14.7618 10.3452 15.0417 10 15.0417C9.65483 15.0417 9.375 14.7618 9.375 14.4167V10.25C9.375 9.90483 9.65483 9.625 10 9.625Z"
        fill={color}
      />
      <path
        d="M9.9974 8.16667C10.4576 8.16667 10.8307 7.79357 10.8307 7.33333C10.8307 6.8731 10.4576 6.5 9.9974 6.5C9.53715 6.5 9.16406 6.8731 9.16406 7.33333C9.16406 7.79357 9.53715 8.16667 9.9974 8.16667Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.71094 10.7917C2.71094 6.76459 5.97553 3.5 10.0026 3.5C14.0297 3.5 17.2943 6.76459 17.2943 10.7917C17.2943 14.8187 14.0297 18.0833 10.0026 18.0833C5.97553 18.0833 2.71094 14.8187 2.71094 10.7917ZM10.0026 4.75C6.66589 4.75 3.96094 7.45495 3.96094 10.7917C3.96094 14.1284 6.66589 16.8333 10.0026 16.8333C13.3394 16.8333 16.0443 14.1284 16.0443 10.7917C16.0443 7.45495 13.3394 4.75 10.0026 4.75Z"
        fill={color}
      />
    </svg>
  );
};

export default React.forwardRef(InfoCircleIcon);
